var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViraataLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 97.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:red;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.51,60.77,66.43.26H81L40.51,97.08,0,.26H14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.43,96.55V.13H107.5V96.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.82,63.27l17,33.41H177.92L163.06,68.14H139.25V96.68H125.17V0h31.31a38.67,38.67,0,0,1,20.65,5.66,32.42,32.42,0,0,1,11.51,12.23,34,34,0,0,1,4.14,16.44,32.8,32.8,0,0,1-16.31,28.55Zm-17.63-7.5a17.81,17.81,0,0,0,10.13-3.09,21.66,21.66,0,0,0,7.23-8.15,22.35,22.35,0,0,0,2.63-10.46,22.49,22.49,0,0,0-10-18.55,17.92,17.92,0,0,0-10-3H139.38V55.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.9,96.42H204.56L241.66,0l41.56,96.42H268.89l-3.41-8H221.75Zm22.76-64.06L226.05,76.29h34.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.09,13.55V.13h61.56V13.55H403.32V96.42H389.37V13.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.4,96.42H296.06L333,0l41.68,96.42H360.39l-3.41-8H313.25Zm22.76-64.06L317.55,76.29h34.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 271.38,
    y: 76.29,
    width: 35.96,
    height: 12.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M435.68,96.42H421.34L458.31,0,500,96.42H485.66l-3.41-8H438.53Zm22.75-64.06-15.6,43.93h34.28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViraataLogo);
export default __webpack_public_path__ + "static/media/viraata-logo.7e159fde547959a0fd2fd16315b01180.svg";
export { ForwardRef as ReactComponent };